import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img"


export default {
  SeoContent:{
    title: 'Credlix News',
    url: WEB_URL+'/en-us/news',
    name:'description',
    description:'List of News in Credlix',
    keyword:'supply chain finance, supply chain finance in USA , supply chain in finance,supply chain finance company', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
},
   


    
}